import { useCallback } from 'react';

import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const Icon = (props) => (
  <svg {...props} viewBox="0 0 467.765 467.765">
    <path
      fill="currentColor"
      d="M58.471 409.294h350.824v58.471H58.471zM292.353 0v58.471h29.235v175.412c0 48.364-39.342 87.706-87.706 87.706s-87.706-39.342-87.706-87.706V58.471h29.235V0H58.471v58.471h29.235v175.412c0 80.597 65.579 146.176 146.176 146.176s146.176-65.579 146.176-146.176V58.471h29.235V0z"
    />
  </svg>
);

const Underline = ({ onItemClick, value, ...otherProps }) => {
  const { quillRef } = useQuillEditorContext();

  const handleToggleValue = useCallback(() => {
    quillRef.current.format('underline', !value, 'user');
    onItemClick();
  }, [value]);

  return (
    <Tooltip
      initialPosition={POSITIONS.BOTTOM}
      childrenElement={__('Underline')}
    >
      <ToolbarItem
        isActive
        icon={Icon}
        onClick={handleToggleValue}
        {...otherProps}
      />
    </Tooltip>
  );
};

Underline.getFormat = (format) => format?.underline;

export default Underline;
